import { useNavigate } from 'react-router-dom';
import { normalizePageIndex } from 'components/pages/ContentManagement/Creatives/Content/Creatives/utils';

type CreativesRendererProps = {
  data?: {
    id: string;
    panels: {
      creative: {
        id: string;
        thumbnailUrl: string;
      };
      order: number;
    }[];
  };
  creativeSetPage?: number;
};

const CreativesRenderer = ({ data, creativeSetPage }: CreativesRendererProps): React.ReactElement => {
  const navigate = useNavigate();

  const handleClick = (id: string): void => {
    navigate(
      `/content-management/previewCreative/${id}`,
      creativeSetPage !== undefined ? { state: { creativeSetPage: normalizePageIndex(creativeSetPage) } } : undefined,
    );
  };

  return (
    <div className="flex space-x-2" data-test-id="creative-set-thumbnails">
      {data?.panels?.map(({ creative: { id, thumbnailUrl }, order }) => (
        <div
          key={`${data?.id}-${id}-${order}`}
          role="presentation"
          className="rounded-md border border-transparent bg-cover bg-center bg-no-repeat w-12 h-12 cursor-pointer"
          onClick={() => handleClick(id)}
          style={{
            backgroundImage: `url(${thumbnailUrl})`,
          }}
          data-test-id={id}
          aria-label={`Preview creative ${id}`}
        />
      ))}
    </div>
  );
};

export default CreativesRenderer;
